module.exports = __webpack_public_path__ + "fonts/TikTokTextBold.41812b4d.otf";